
































































































































import Vue from "vue";

import { default as moment } from "moment-timezone";

import { isComputer } from "@/service/DeviceType";

import {
  Dame,
  ladenoeffnung,
  ladenoeffnungSonntag,
  ladenschluss,
  currentTimestamp,
  PopoverMode,
  DienstplanEintrag,
  DAY_FORMAT,
  WOCHENTAGE,
} from "@/api/Termine";

export interface DienstUpdateEvent {
  popoverMode: PopoverMode;
  eintrag: DienstplanEintrag;
}

declare type TimePreselectionMode = "early" | "late" | "custom";

export default Vue.extend({
  name: "DienstplanPopover",
  data() {
    return {
      // Einstellungen für Popover-Dialog
      popoverMode: "create" as PopoverMode,
      popoverTitle: "",
      popoverHinweistext: "",
      selectTimes: false,
      showPopover: false,
      gewaehlterTag: currentTimestamp(),

      // Dienstdetails
      gast: "",
      dame: {} as Dame,
      eintrag: {} as DienstplanEintrag,
      von: new Date(),
      bis: new Date(),
      minVonDate: new Date(),
      maxVonDate: new Date(),
      minBisDate: new Date(),
      maxBisDate: new Date(),
      minDuration: isComputer() ? 30 : 15,
      maxDuration: isComputer() ? 240 : 255,
    };
  },
  computed: {
    ganzerTagButtonLabel() {
      const startZeit =
        (this as any).gewaehlterTag.isoWeekday() == 7
          ? ladenoeffnungSonntag
          : ladenoeffnung;
      return `Ganzer Tag (${startZeit} bis ${ladenschluss} Uhr)`;
    },
  },
  methods: {
    show(popoverMode: PopoverMode, dame: Dame, eintrag: DienstplanEintrag) {
      console.log(dame);
      this.popoverMode = popoverMode;
      this.selectTimes = popoverMode == "create";
      this.dame = dame;
      this.eintrag = eintrag;
      this.gewaehlterTag = moment(eintrag.von);

      const refdate = this.gewaehlterTag
        .clone()
        .hour(0)
        .minute(0);
      this.minVonDate = new Date(refdate.unix() * 1e3);

      const vonZeitpunkt =
        eintrag && eintrag.id ? moment(eintrag.von) : refdate.clone();
      this.von = new Date(vonZeitpunkt.unix() * 1e3);
      console.debug("Termin ist um " + this.von.toString());
      this.maxVonDate = new Date(refdate.hour(ladenschluss).unix() * 1e3);

      const bisZeitpunkt =
        eintrag && eintrag.id
          ? moment(eintrag.bis)
          : this.gewaehlterTag
              .clone()
              .hour(23)
              .minute(59);
      this.bis = new Date(bisZeitpunkt.unix() * 1e3);
      this.minBisDate = new Date(
        refdate
          .hour(0)
          .minute(0)
          .unix() * 1e3
      );
      this.maxBisDate = new Date(
        refdate
          .add(1, "day")
          .clone()
          .hour(23)
          .minute(59)
          .unix() * 1e3
      ); // Termin endet spätestens irgendwann in der Nacht oder morgens am nächsten Tag

      const datumFormatiert = `${
        WOCHENTAGE[vonZeitpunkt.isoWeekday()]
      }, ${vonZeitpunkt.format(DAY_FORMAT)}`;
      const letzterBuchstabe = dame.kuenstlername
        .charAt(dame.kuenstlername.length - 1)
        .toLowerCase();
      const possessivSuffix =
        letzterBuchstabe == "s" ||
        letzterBuchstabe == "x" ||
        letzterBuchstabe == "ß"
          ? "'"
          : "s";
      const wessen = `${dame.kuenstlername}${possessivSuffix}`;
      switch (popoverMode) {
        case "create":
          this.popoverTitle = `Neuer Dienst bei ${dame.kuenstlername}`;
          this.popoverHinweistext = `Hiermit tragen Sie ${dame.kuenstlername} einen Dienst am ${datumFormatiert} ein.`;
          break;
        case "edit":
          this.popoverTitle = `${wessen} Dienst bearbeiten`;
          this.popoverHinweistext = `Hier kann ${wessen} Dienst am ${datumFormatiert} (nach)bearbeitet, bzw. verschoben, oder gelöscht werden.`;
          break;
        default:
          this.showPopover = false;
          return;
      }

      this.showPopover = true;
    },

    // Bei Neuanlegen eines Dienstes: Vorbelegung
    preselectZeit(preselection: TimePreselectionMode) {
      const tag = this.gewaehlterTag.clone();
      // Von-Zeitpunkt
      switch (preselection) {
        case "custom":
        case "early":
          this.von = new Date(
            tag
              .hour(tag.isoWeekday() == 7 ? ladenoeffnungSonntag : ladenoeffnung)
              .minutes(0)
              .unix() * 1e3
          );
          break;
        case "late":
          this.von = new Date(
            tag
              .hour(15)
              .minutes(0)
              .unix() * 1e3
          );
          break;
      }
      // Bis-Zeitpunkt
      switch (preselection) {
        case "early":
          this.bis = new Date(
            tag
              .hour(15)
              .minutes(0)
              .unix() * 1e3
          );
          break;
        case "late":
        case "custom":
          this.bis = new Date(
            tag
              .hour(ladenschluss)
              .minutes(0)
              .unix() * 1e3
          );
          break;
      }
      this.selectTimes = false;
    },

    // Behandeln von Eingabemasken/Dialog für
    // Neuanlage/Bearbeitung/Sperrung/Löschung
    popoverYesSave() {
      this.showPopover = false;
      const bis = this.gewaehlterTag
        .clone()
        .hour(this.bis.getHours())
        .minute(this.bis.getMinutes());
      if (this.bis.getHours() < this.von.getHours()) {
        bis.add(1, "day");
      }
      this.$emit("update", {
        popoverMode: this.popoverMode,
        eintrag: {
          id: this.eintrag?.id,
          studio: this.eintrag?.studio,
          dame: this.dame,
          von: this.gewaehlterTag
            .hour(this.von.getHours())
            .minute(this.von.getMinutes())
            .format(),
          bis: bis.format(),
        } as DienstplanEintrag,
      } as DienstUpdateEvent);
    },
    popoverNoAbort() {
      this.showPopover = false;
    },
    popoverDelete() {
      if (
        window.confirm("Soll der gewählte Dienst wirklich gelöscht werden?")
      ) {
        this.$emit("update", {
          popoverMode: "delete",
          eintrag: this.eintrag,
        } as DienstUpdateEvent);
        this.showPopover = false;
      }
    },
  },
});
